import { render } from "./SettingButton.vue?vue&type=template&id=2db182ec&scoped=true"
import script from "./SettingButton.vue?vue&type=script&lang=js"
export * from "./SettingButton.vue?vue&type=script&lang=js"

import "./SettingButton.vue?vue&type=style&index=0&id=2db182ec&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2db182ec"

export default script